import {Lang} from 'contexts/LangContext';
import {
    NavigationConfig,
    NavigationColumnGroup,
    NavigationItem,
    ConfigParams,
    NavigationSectionType,
} from 'units/navigation/models';
import getConfigItems, {DropdownTypes} from '../constants';

export default function (params: ConfigParams): NavigationConfig {
    const {locale, i18n, isAuthorized, env, featureFlags} = params;
    const {common, services, features, community, contacts, solutions} = getConfigItems(
        locale,
        i18n,
        env,
    );
    const {lang} = locale;

    return [
        // services section
        {
            title: services.title,
            isFullscreen: true,
            type: NavigationSectionType.Services,
            dropdown: DropdownTypes.Extended,
            footer: [common.services, common.marketplace, common.mobileApp, common.statusboard],
        },

        // solutions section
        {
            title: solutions.title,
            isFullscreen: true,
            type: NavigationSectionType.Solutions,
            dropdown: DropdownTypes.Extended,
            footer: [common.solutions],
        },

        // features section
        {
            title: features.title,
            dropdown: DropdownTypes.Default,
            columns: [
                {
                    colspan: 2,
                    groups:
                        lang === Lang.Ru
                            ? [
                                  {
                                      items: [
                                          features.items.prices,
                                          features.items['for-business'],
                                          featureFlags.scaleNavigation &&
                                              features.items['for-education-and-science'],
                                          features.items.cases,
                                      ].filter(Boolean),
                                  },
                                  {
                                      items: [
                                          features.items.security,
                                          featureFlags.scaleNavigation &&
                                              features.items['insurance-offer'],
                                          features.items['partners/catalogue'],
                                          features.items['docs/support/overview'],
                                      ].filter(Boolean),
                                  },
                              ]
                            : [
                                  {
                                      items: [
                                          features.items['solutions/gateway-to-russia'],
                                          features.items.prices,
                                          features.items.cases,
                                      ],
                                  },
                                  {
                                      items: [
                                          features.items.security,
                                          features.items['docs/support/overview'],
                                      ],
                                  },
                              ],
                    footer: [
                        {
                            items: [features.boost],
                        },
                        lang === Lang.Ru && {
                            items: [features.partnerPropgram],
                        },
                    ].filter(Boolean) as NavigationColumnGroup[],
                },
                {
                    groups: [
                        {
                            items: [
                                common.services,
                                common.marketplace,
                                lang === Lang.Ru && common.events,
                                common.mobileApp,
                                common.salesAction,
                            ].filter(Boolean) as NavigationItem[],
                        },
                    ],
                },
            ],
        },

        // community section
        lang === Lang.Ru && {
            title: community.title,
            dropdown: DropdownTypes.Default,
            columns: [
                {
                    groups: [
                        {
                            items: [
                                community.items.features,
                                featureFlags.scaleNavigation && community.items['content-program'],
                                community.items.events,
                                community.items.blog,
                            ].filter(Boolean),
                        },
                    ],
                },
                {
                    groups: [
                        {
                            items: [common.marketplace, common.statusboard, common.telegram],
                        },
                    ],
                },
            ],
        },

        common.prices,
        common.docs,

        // contacts section
        lang !== Lang.Ru && !isAuthorized
            ? common.contact
            : {
                  title: contacts.title,
                  dropdown: DropdownTypes.Default,
                  columns: [
                      {
                          groups: [
                              {
                                  items: [
                                      common.sales,
                                      isAuthorized && common.support,
                                      lang === Lang.Ru && common.tender,
                                  ].filter(Boolean),
                              },
                          ],
                      },
                  ],
              },
    ].filter(Boolean) as NavigationConfig;
}
